// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"185d44ae","513":"d2131220","545":"a275611f"}[chunkId] + ".chunk.js";
};